import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
// import { MatNativeDateModule } from "@angular/material/core";
import { Global } from "./global";
import { ToastrModule } from "ngx-toastr";
import { SharedModule } from "./shared/shared.module";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { AppGlobalErrorhandler } from "src/app/error-handler.service";
import { ErrorHandler } from "@angular/core";
import { ConvertToINRPipe } from "./shared/custom.pipe";
import { CommonModule } from "@angular/common";
import { HeaderModule } from "./header/header.module";
import { FooterModule } from "./footer/footer.module";
import { Angulartics2Module } from 'angulartics2';
// import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NgOtpInputModule } from 'ng-otp-input';
import { MatInputModule } from "@angular/material/input";

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        // MatNativeDateModule,
        MatInputModule,
        ToastrModule.forRoot({ positionClass: "toast-top-right" }),
        SharedModule,
        NgxUiLoaderModule,
        CommonModule,
        HeaderModule,
        FooterModule,
        Angulartics2Module.forRoot(),
        // MatBottomSheetModule,
        NgOtpInputModule], providers: [
        Global,
        AppComponent,
        ConvertToINRPipe,
        { provide: ErrorHandler, useClass: AppGlobalErrorhandler },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
